import PropTypes from 'prop-types';
import React from 'react';

import * as items from './items';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @component ItemDispatcher
 * @props (see propTypes)
 */
const ItemDispatcher = ({
    item = null,
    ...remainingProps
}) => {
    if (!item?.__typename) { return null; }

    let itemKey = Object.keys(items).find((key) => items[key].__typename === item.__typename);

    const ItemComponent = items[itemKey];

    return (
        <ItemComponent
            {...item}
            {...remainingProps} />
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

ItemDispatcher.propTypes = {
    item:      PropTypes.object.isRequired
};

export default ItemDispatcher;
